<template>
  <custom-popover class="push-popover" ref="popover" :backdrop="true" @close="$emit('close')">
    <div class="content" :class="{ 'upload-content': showUploadOption }">
      <div class="header">
        <div class="left">
          <h2>{{ $t("push.title") }}</h2>

          <infobox bottom :width="270" class="info-box" slot="info">
            <a slot="icon" target='_blank' href='https://help.icrobotics.com/push-texts-for-specific-ids'> 
            <span >
              <i class="fa-light fa-question-circle"></i>
            </span>
          </a>
            <p class="text-small description" v-html="$t('push.info-desc')"></p>
          </infobox>
        </div>
        <div class="header-actions">
          <button class="btn btn-xs btn-secondary" @click="showUploadOption = !showUploadOption">
            <span v-show="!showUploadOption"> <i class="fa-light fa-file-upload"></i></span>
            <span v-show="showUploadOption"> <i class="fa-light fa-search"></i></span>
            {{ showUploadOption ? "Browse" : "Upload" }}
          </button>
          <div class="close-popover" @click="$emit('close')">
            <i class="fa-light fa-times"></i>
          </div>
        </div>
      </div>

      <div v-if="!showUploadOption" class="product-select">
        <main>
          <div class="search-area">
            <div class="search-filter">
              <custom-input
                ref="searchinput"
                @input="onFilterChange(filter)"
                autoComplete="off"
                type="text"
                name="searchfilter"
                :placeholder="$t('search')"
                v-model="filter"
                :label="$t('push.search')"
              />
              <!-- :supportingText="!searching && searchResults.length == 0 && filter.length ? $t('tp-data-popover.no-result1')  +  filter  + $t('tp-data-popover.no-result2') : 'Search products from your CMS' " -->
              <div class="input-icons">
                <div @click="onEraseFilter(filter)" v-if="filter.length" class="erase-wrapper">
                  <i class="close-icon fa-light fa-times"></i>
                </div>
                <div v-show="searching">
                  <i class="searching fa-light fa-circle-notch fa-spin"></i>
                </div>
                <div v-show="!searching" class="search-icon">
                  <i class="fa-light fa-search"></i>
                </div>
              </div>
            </div>
            <ul class="result-list custom-scrollbar-light">
              <li class="result-item" v-for="result in searchResults" :key="result.id">
                <div class="main-info">
                  <div>
                    {{ result.referenceName }}
                  </div>
                  <span class="text-small text-muted">
                    {{ result.id }}
                  </span>
                </div>

                <checkbox
                  lightLabel
                  :label="''"
                  :name="result.id"
                  :value="result.id"
                  @change="toggleResultId(result)"
                  :checked="isSelected(result.id)"
                />
              </li>
              <div v-if="!searching && searchResults.length == 0 && filter.length" class="no-results text-muted">
                {{ $t("tp-data-popover.no-result1") }} '{{ filter }}' {{ $t("tp-data-popover.no-result2") }}
              </div>
            </ul>
          </div>
          <div class="selection-area">
            <div class="top">
              <h4>{{ $t("push.selected-title") }}</h4>
            </div>
            <ul class="result-list custom-scrollbar-light">
              <li class="result-item" v-for="result in selectedForPush" :key="result.id">
                <div class="main-info">
                  <div>
                    {{ result.referenceName }}
                  </div>
                  <span class="text-small text-muted">
                    {{ result.id }}
                  </span>
                </div>
                <button @click="toggleResultId(result)" class="btn btn-icon-only">
                  <span>
                    <i class="fa-light fa-times"></i>
                  </span>
                </button>
                <!-- <checkbox
                  lightLabel
                  :label="''"
                  :name="result.id"
                  :value="result.id"
                  @change="toggleResultId(result)"
                  :checked="isSelected(result.id)"
                /> -->
              </li>

              <div v-if="selectedForPush.length == 0">
                <p class="description text-muted empty-list">{{ $t("push.empty-selection") }}</p>
              </div>
            </ul>

            <div class="push-actions">
              <!-- @click="$emit('push', selectedForPush)" -->

              <span v-if="pushFromSelectionError" class="summary text-small text-danger">{{
                $t("standard-error")
              }}</span>
              <span v-else class="summary text-small text-muted"> {{ selectedForPush.length }} {{ $t('push.selection-count') }}</span>
              <button class="btn btn-primary" :disabled="!selectionValid" @click="onPushIds()">
                {{ $t("push.btn-push") }}
              </button>
            </div>
          </div>
        </main>
      </div>

      <div v-else>
        <form @submit.stop.prevent enctype="multipart/form-data" class="upload-form">
          <div class="top">
            <h4>{{ $t('push.upload-title') }}</h4>
            <p class="description text-muted" v-html="$t('push.upload-description')"></p>
          </div>
          <custom-input
            type="text"
            name="fileName"
            id="fileName"
            :placeholder="$t('push.upload-placeholder')"
            :label="$t('push.upload-label')"
            v-model="fileUpload.name"
            isReadonly
            isDisabled
            boxed
            :supportingText="
              pushFromSpreadsheetError
                ? $t('push.upload-error')
                : ''
            "
          />
          <input
            ref="file"
            type="file"
            name="fileInput"
            accept=".xlsx, .csv, .xls"
            class="input-file"
            @change="selectedFile"
          />

          <div class="upload-actions">
            <button type="button" class="btn btn-secondary" @click="$refs.file.click()">
              {{ $t("dummy-uploader.browse") }}
            </button>
            <button
              ref="submit"
              type="submit"
              class="btn btn-primary"
              :disabled="!fileUploadvalid"
              @click="onPushIds(true)"
            >
            {{ $t("push.btn-push") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </custom-popover>
</template>

<script>
import ConfirmModal from "@/components/modals/ConfirmModal";
import CustomPopover from "@/components/CustomPopover";
import Infobox from "@/components/Infobox";
import Checkbox from "@/components/Checkbox";
import debounce from "lodash/debounce";
export default {
  components: {
    CustomPopover,
    Infobox,
    Checkbox
  },
  props: {
    publication: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      filter: "",
      singleItem: "",
      noMatch: false,
      searching: false,
      onFilterChangeDebounce: debounce((filter) => {
        if (filter.length) {
          this.noMatch = false;
          this.searchResults = [];
          this.search(filter);
        } else {
          this.searchResults = [];
          this.noMatch = true;
          this.searching = false;
        }
      }, 500),
      searchResults: [],
      selectedForPush: [],
      showUploadOption: false,
      fileUpload: {
        file: null,
        name: ""
      },
      pushFromSpreadsheetError: false,
      pushFromSelectionError: false
    };
  },

  methods: {
    onFilterChange(filter) {
      this.searching = true;
      this.onFilterChangeDebounce(filter);
    },

    search(query) {
      this.$store
        .dispatch("searchVariables", {
          filter: query ? query : this.filter,
          templateId: this.publication.id
        })
        .then((result) => {
          this.searchResults = result;
          if (result.length == 0) {
            this.noMatch = true;
          } else {
            this.noMatch = false;
          }
        })
        .finally(() => {
          this.searching = false;
        });
    },

    isSelected(id) {
      return this.selectedForPush.some((o) => o.id === id);
    },

    toggleResultId(productReference) {
      this.pushFromSelectionError = false;
      if (this.selectedForPush.some((item) => item.id == productReference.id)) {
        this.selectedForPush = this.selectedForPush.filter((item) => item.id !== productReference.id);
      } else {
        this.selectedForPush.push(productReference);
      }
    },

    selectedFile() {
      this.pushFromSpreadsheetError = false;
      if (!this.$refs.file.files[0]) {
        this.fileUpload.file = null;
        this.fileUpload.name = "";
      } else {
        this.fileUpload.file = this.$refs.file.files[0];
        this.fileUpload.name = this.fileUpload.file.name;
        this.$refs.submit.focus();
      }
    },

    onEraseFilter(filter) {
      this.filter = "";
      filter = "";
      this.onFilterChange(filter);
      this.$refs.searchinput.focus();
    },

    onPushIds(fromSpreadsheet) {
      this.$modal.show(
        ConfirmModal,
        {
          title: this.$t("push.modal.title"),
          description:
            this.$t("push.modal.description1") +
            this.publication.sources[0].name +
            this.$t("push.modal.description2"),
          onConfirm: () => {
            fromSpreadsheet ? this.pushIdsFromSpreadsheet() : this.pushIdsFromSelection();
          }
        },
        { width: 350, height: "auto" }
      );
    },
    pushIdsFromSelection() {
      this.pushFromSelectionError = false;
      this.$store
        .dispatch("pushIdsToQueue", {
          id: this.publication.id,
          contentIds: this.selectedForPush.map((item) => item.id)
        })
        .then(() => {
          this.$emit("close");
        })
        .catch((e) => {
          console.log("err");
          this.pushFromSelectionError = true;
        });
    },

    pushIdsFromSpreadsheet() {
      this.pushFromSpreadsheetError = false;
      this.$store
        .dispatch("pushFromSpreadsheetToQueue", { id: this.publication.id, file: this.fileUpload.file })
        .then(() => {
          this.$emit("close");
        })
        .catch((e) => {
          this.pushFromSpreadsheetError = true;
        });
    }
  },
  computed: {
    fileUploadvalid() {
      return this.fileUpload.file;
    },
    selectionValid() {
      return this.selectedForPush.length > 0;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.searchinput.focus();
      // hack to add something to the list when opening
      this.search("1");
    });
  }
};
</script>

<style lang="less">
#app .push-popover h4 {
  font-size: 14px;
  font-weight: 700;
  padding-left: 8px;
  color: var(--charcoal-80);
}
.push-popover {
  .content {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px -2px 4px rgba(0, 0, 0, 0.25);
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: var(--standard-border-radius);
    // width: 75%;
    width: 750px;
    // height: 90%;
    height: 400px;
    z-index: 99;
    background: #fff;
    color: var(--charcoal);
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: var(--background-white);
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
      position: relative;
      padding: 14px 24px 14px 24px;
      border-radius: 10px 10px 0 0;

      h2 {
        margin-bottom: 0;
      }
      .description {
        margin: 6px 0 0 0;
        padding: 0;
      }
      .close-popover {
        cursor: pointer;
      }

      .left {
        display: flex;
        align-items: center;
        gap: 4px;
      }
    }
    .header-actions {
      display: flex;
      gap: 12px;
      align-items: center;
    }

    &.upload-content {
      height: auto;
    }
  }

  .product-select {
    padding: 0 12px;
    main {
      display: flex;
      width: 100%;
      position: relative;
      gap: 12px;
      .search-area,
      .selection-area {
        width: 50%;

        .top {
          display: flex;
          padding-top: 12px;
        }
      }
      .selection-area {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .push-actions {
          padding: 8px 0;
          padding-bottom: 0;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          gap: 12px;
        }
        .top {
          h4 {
            margin-bottom: 12px;
          }
        }
        .empty-list {
          padding: 8px;
        }
      }
    }

    .search-filter {
      position: relative;
      .search-input {
        input {
          padding-right: 40px;
        }
      }
      .input-icons {
        display: flex;
        flex-direction: row;
        gap: 6px;
        position: absolute;
        right: 18px;
        bottom: 10px;
      }
    }
  }
  .result-list {
    height: 250px;
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 0;
    margin-bottom: 0;
  }
  .result-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 4px 8px;
    .container-checkbox {
      margin-bottom: 20px;
    }
    &:hover {
      background-color: var(--alabaster-80);
    }
  }

  .upload-form {
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    .input-file {
      opacity: 0;
      pointer-events: none;
      position: absolute;
      cursor: pointer;
    }

    .top {
      max-width: 360px;
      .description {
        margin-bottom: 0;
        padding-left: 8px;
      }
    }
    .upload-actions {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
    }
  }
}
</style>
